import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/Home.vue";
import About from "../pages/About.vue";
import Contact from "../pages/Contact.vue";
import Portfolio from "../pages/Portfolio.vue";
import PageNotFound from "../pages/PageNotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "Inicio" },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: { title: "Sobre mí" },
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: { title: "Contactame" },
  },
  {
    path: "/portfolio",
    name: "Portafolio",
    component: Portfolio,
    meta: { title: "Portafolio" },
  },
  { path: "*", component: PageNotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
